import { render, staticRenderFns } from "./Curriculo.vue?vue&type=template&id=2b4a612b&"
import script from "./Curriculo.vue?vue&type=script&lang=js&"
export * from "./Curriculo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports